import { KeyValueLabel, NoValue, PointOfSaleInfos } from '@tribeauto/ngx-mobilite-material';
import { TranslateService } from '@ngx-translate/core';

export const pos = [
  { key: '7006063028', value: '7006063028', label: '7006063028 - ACTENA AUTOMOBILES' },
  { key: '7006555478', value: '7006555478', label: '7006555478 - ARAMIS ARCUEIL' },
  { key: '7206607576', value: '7206607576', label: '7206607576 - JAGUAR TEST' },
  { key: '7006597108', value: '7006597108', label: '7006597108 - TESLA FRANCE' },
  { key: '7005288394', value: '7005288394', label: '7005288394 - HONDA TEST' },
  { key: '7205183272', value: '7205183272', label: '7205183272 - SUZUKI TEST' },
  { key: '7206637748', value: '7206637748', label: '7206637748 - BPM' },
  { key: '7006651343', value: '7006651343', label: '7006651343 - TEST CCK - TRIBE MOBILITE' }
];

export const posAll: KeyValueLabel = { key: 'all', value: 'all', label: 'application.records.all' };

export const getWebStoreIds = (posValue: string | NoValue, tveiListMap: KeyValueLabel[]): string[] => {
  if (posValue) {
    return posValue === posAll.value
      ? tveiListMap.map(tvei => tvei.value).filter(value => value !== posAll.value)
      : [posValue];
  }
  return [];
};

export const pointOfSalesToKeyValueLabelsWithAllOption = (
  pointOfSales: PointOfSaleInfos[] | NoValue,
  translateService: TranslateService
): KeyValueLabel[] => {
  if (pointOfSales) {
    if (pointOfSales.length > 1 && !pointOfSales.some(pointOfSale => pointOfSale.name === posAll.label)) {
      pointOfSales.unshift({ id: '0', name: posAll.label!, tvei: posAll.value });
    }

    return pointOfSales
      .map(pointOfSale => ({
        key: pointOfSale.tvei,
        value: pointOfSale.tvei,
        label:
          pointOfSale.name === posAll.label
            ? translateService.instant(pointOfSale.name)
            : `${pointOfSale.tvei} - ${pointOfSale.name}`
      }))
      .sort((a, b) => Number(a.key) - Number(b.key));
  }
  return [];
};
